import "@mantine/core/styles.css";

import { MantineProvider } from "@mantine/core";
import { dovachTheme } from "@dovach/ui-primitives";
import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import "./index.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

// Operator admin is English-first (LTR) — internal tool, not the Hebrew customer surface.
ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <MantineProvider theme={dovachTheme} defaultColorScheme="auto">
      <App />
    </MantineProvider>
  </React.StrictMode>,
);
